module.exports = __webpack_public_path__ + "static/5-df1dd470dae51cd5ff6f717d7a7a7fce.jpg";